import { forwardRef } from 'react';

type FormTitleProps = {
  titleSize?: 'large' | 'extraLarge';
  text: string;
  subtext?: string | React.ReactNode;
};

export const FormTitle = forwardRef<HTMLDivElement, FormTitleProps>(
  ({ titleSize, text, subtext, ...rest }, ref) => {
    const titleFontSize =
      titleSize === 'extraLarge' ? 'text-h1 my-12' : 'text-h2 my-4';
    return (
      <>
        <div
          {...rest}
          ref={ref}
          className={`text-brand-primary ${titleFontSize}`}
        >
          <h1 data-testid="before-you-start-title">{text}</h1>
        </div>
        {typeof subtext === 'string' ? (
          <div {...rest} ref={ref} className="text-brand-primary body-2 my-4">
            {subtext}
          </div>
        ) : (
          <>{subtext}</>
        )}
      </>
    );
  },
);

FormTitle.displayName = 'FormTitle';
